export const helpers = {
  validate_cellphone: {
    validity: 'Por favor, informe um telefone válido',
  },
  validate_email: {
    registered: 'Este email já está registrado',
    validity: 'Por favor, informe um e-mail válido',
  },
};
